'use strict';

const SoaModel = require('bunsen/models/SoaModel');
let PublicationGroup;

PublicationGroup = SoaModel.extend(
    {
        getName() {
            return this.get('name');
        },
        isStorefront() {
            return this.getName() === PublicationGroup.STOREFRONT;
        },
        isMarketplace() {
            return this.getName() === PublicationGroup.MARKETPLACE;
        },
        isFeatured() {
            return this.getName() === PublicationGroup.FEATURED;
        },
        isSale() {
            return this.getName() === PublicationGroup.SALE;
        },
        isContemporary() {
            return this.getName() === PublicationGroup.CONTEMPORARY;
        }
    },
    {
        STOREFRONT : 'DEALER_STOREFRONT',
        MARKETPLACE : 'MARKETPLACE',
        FEATURED : 'FEATURED',
        SALE : 'SALE',
        CONTEMPORARY: 'CONTEMPORARY'
    }
);

module.exports = PublicationGroup;



// WEBPACK FOOTER //
// ./~/bunsen/models/inventory/PublicationGroup.es.js